import DashboardParkingAreaLeftMenuLayout from "./dashboardParkingAreaLeftMenuLayout";

export default DashboardParkingAreaLeftMenuLayout;